<template>
  <div class="row">
  <!-- timeline item 1 left dot -->
  <div class="col-auto text-center flex-column d-none d-sm-flex">
    <div class="row h-50">
      <div :class="'col' + (index > 0 ? ' border-right border-success' : '')">&nbsp;</div>
      <div class="col">&nbsp;</div>
    </div>
    <h5 class="m-2">
      <span class="badge badge-pill bg-success">&nbsp;</span>
    </h5>
    <div class="row h-50">
      <div :class="'col' + (index < (length - 1) ? ' border-right border-success' : '')">&nbsp;</div>
      <div class="col">&nbsp;</div>
    </div>
  </div>
  <!-- timeline item 1 event content -->
  <div class="col py-2">
    <div class="card">
      <div class="card-body">
        <div class="float-right text-muted">{{row.date | moment-complete}}</div>
        <h4 class="card-title text-muted">{{ row.title }}</h4>
        <p class="card-subtitle mb-2 text-muted">{{row.description !== null ? row.description  : ''}} {{row.reason ? ' - ' + row.reason : ''}}</p>
        <div v-if="row.dateSettled !== null">
          <p class="card-subtitle mb-2 text-muted">{{row.dateSettled !== null ? row.dateSettled : ''}}</p>
        </div>
         <!--  <p class="card-subtitle mb-2 text-muted" v-if="row.dateSettled !== null"> Data pagamento:  {{row.dateSettled | moment-date }}</p>-->
        <div class="card-text">
          <ul v-if="row.itens">
            <li v-for="(v, k) in row.itens" v-bind:key="k">
              <div v-if="k == 'Link' && v">
                <span><a :href="v" target="_blank">Portal de boletos</a></span><br />
                <span><a :href="v" target="_blank" class="refinan">Refinanciamento</a></span>
              </div>
              <span v-else>{{k}}: {{v}}</span>
            </li>
          </ul>
          <div class="accordion" :id="'accordion' + groupName + index" v-if="row.code">
            <div class="card">
              <div class="card-header" :id="'heading' + groupName + index">
                <h5 class="mb-0">
                  <button class="btn btn-link collapsed" type="button" data-toggle="collapse" :data-target="'#collapse' + groupName + index" aria-expanded="false" :aria-controls="'collapse' + groupName + index">
                    DEBUG
                  </button>
                </h5>
              </div>
              <div :id="'collapse' + groupName + index" class="collapse" :aria-labelledby="'heading' + groupName + index" :data-parent="'#accordion' + groupName + index">
                <div class="card-body">
                  <pre><code>{{ row.code }}</code></pre>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-for="j in img" v-bind:key="j.id">
          <img :src="j.data" class="document-image"/>
        </div>
      </div>
    </div>
  </div>
  </div>
</template>
<script>
export default {
  props: ['row', 'index', 'length', 'groupName'],
  data () {
    return {
      img: []
    }
  },
  mounted () {
    this.refreshImages()
    this.updateRefinancingUrl()
  },
  methods: {
    getImage (imageUrl) {
      console.log('getting image ' + imageUrl)
      this.$http.get(imageUrl)
        .then(function (res) {
          this.img.push({src: imageUrl, data: 'data:' + res.data.contentType + ';base64,' + res.data.image})
        })
        .catch(function (res) {
          console.log('Error')
          console.log(res)
        })
    },
    refreshImages () {
      console.log('refresh images')
      if (this.row.images) {
        for (var i = 0; i < this.row.images.length; i++) {
          const f = this.img.find(item => item.src === this.row.images[i].src)
          if (!f) {
            this.getImage(this.row.images[i].src)
          }
        }
      }
    },
    updateRefinancingUrl () {
      let refinan = document.getElementsByClassName('refinan')
      var arr = [].slice.call(refinan)
      arr.map((item) => {
        // console.info(item)
        if (item.hash) {
          let newHash = item.hash.replace('#/', '')
          // console.info('item.hash ' + item.hash)
          // console.info('newHash ' + newHash)
          item.href = process.env.REFINAN_URL + newHash
        }
      })
    }
  }
}
</script>
<style lang="css">
</style>



// WEBPACK FOOTER //
// src/components/partial/timeline/TimelineItem.vue